import Icon from '../components/Icon.vue'

Icon.register({
  wifi: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M634.9 154.9C457.7-9 182.2-8.9 5.1 154.9-1.6 161-1.7 171.5 4.7 177.9L39 211.8C45.1 217.9 55 218.1 61.4 212.2 207.3 78.5 432.7 78.5 578.6 212.2 585 218.1 594.9 217.9 601 211.8L635.3 177.9C641.7 171.5 641.6 161 634.9 154.9zM320 352C284.6 352 256 380.6 256 416S284.6 480 320 480 384 451.4 384 416 355.4 352 320 352zM522.7 268.4C407.4 166.5 232.5 166.6 117.3 268.4 110.4 274.5 110.2 285.1 116.8 291.6L151.2 325.5C157.2 331.5 166.9 331.9 173.3 326.4 257.2 253.8 383 253.9 466.7 326.4 473.1 331.9 482.8 331.5 488.8 325.5L523.2 291.6C529.8 285.1 529.6 274.5 522.7 268.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/wifi.js
// module id = jn8r
// module chunks = 144